import { SettlementType } from "@/models/billingPaymentSchedule";
import { getJSTCurrentTime } from "@/util/datetime";

export const BillingPaymentScheduleConstants = {
  Title: "請求・支払スケジュール",
  PrevMonth: "前月",
  NextMonth: "翌月",
  InvoiceSendOn: "請求書送付日",
  DirectDebitOn: "口座振替の引落日",
  BankTransferDueOn: "銀行振込の期日",
  PaymentNoticeSendOn: "支払通知書送付日",
  OutsourcingFeePaymentOn: "業務委託料の支払日",
  Preparing: "ただいまスケジュールを準備中です",
  FetchError: "データの取得に失敗しました",
  Legend: "凡例",
  // カレンダー枠内に収まるよう短縮した日付項目名（正式名称はホバー時に表示する）
  InvoiceSendOnAbbr: "請求書",
  DirectDebitOnAbbr: "口座振替",
  BankTransferDueOnAbbr: "銀行振込",
  PaymentNoticeSendOnAbbr: "支払通知",
  OutsourcingFeePaymentOnAbbr: "委託料",
} as const;

export const settlementLabel = (type: SettlementType): string =>
  type === "DIRECT_DEBIT"
    ? BillingPaymentScheduleConstants.DirectDebitOn
    : BillingPaymentScheduleConstants.BankTransferDueOn;

export const settlementLabelAbbr = (type: SettlementType): string =>
  type === "DIRECT_DEBIT"
    ? BillingPaymentScheduleConstants.DirectDebitOnAbbr
    : BillingPaymentScheduleConstants.BankTransferDueOnAbbr;

// yyyyMM 形式（例: "202603"）
export const getCurrentYearMonth = (): string =>
  getJSTCurrentTime("date").slice(0, 7).replace("-", "");

// カレンダー上で表示可能な最も古い年月(yyyyMM形式)。2025年以前は表示させない。
export const MIN_YEAR_MONTH = "202601";
